module.exports = __webpack_public_path__ + "img/page-detail-title.73d945b7.png";